import { render, staticRenderFns } from "./Personalreport.vue?vue&type=template&id=72260580&scoped=true&"
import script from "./Personalreport.vue?vue&type=script&lang=js&"
export * from "./Personalreport.vue?vue&type=script&lang=js&"
import style0 from "./Personalreport.vue?vue&type=style&index=0&id=72260580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72260580",
  null
  
)

export default component.exports